import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2ab7ca', //  Bleu clair
      soft: '#d1eaeeff', // Bleu clair
    },
    secondary: {
      main: '#e7dfc6', // beige doux
    },
    darkfocus: {
      main: '#1E2A38', // magenta
    },
    focus: {
      main: '#843b62', // Magenta
    },
    grey: {
      main: '#E0E0E0', // Gris clair
    },
    validation:{
      main: '#A3B18A', // Vert sauge
    },
    alerte:{
      main: '#fe4a49', // Rouge doux
    },
    background: {
      default: '#ffffff', // Blanc
      paper: '#ffffff', // Blanc pour les cartes et les dialogues
    },
  },
  typography: {
    fontFamily: 'Merriweather Sans, Inter, Roboto, Arial, sans-serif',
    h1: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 600,
      fontSize: '52px',
      color: '#2ab7ca', // Bleu clair
    },
    h2: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '34px',
      color: '#2ab7ca', // Bleu clair
    },
    h4: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '26px',
      color: '#2ab7ca', // Bleu clair
    },
    subtitle1: {
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '20px',
      fontWeight: 600,
      color: '#000000'
    },
    body1:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '18px',
      fontWeight: 400,
      color: '#000000'
    },
    body2: {
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: 400,
      color: '#000000',
    },
    lineHeight: 1.5,
    button: {
      fontFamily: 'Merriweather Sans, Roboto, sans-serif',
      fontSize: '18px',
      fontWeight: 500,
      color: '#f5f1eb',
      textTransform: 'none', // Pas de majuscules automatiques
    },
  },

  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff', // Couleur de fond de l'AppBar
          borderBottom: '1px solid #d1eaeeff', // Bordure en bas
          boxShadow: 'none', // Pas d'ombre
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '60px', // Hauteur minimale de la barre d'outils
          display: 'flex',
          justifyContent: 'space-between', // Espace entre les éléments
          alignItems: 'center', // Alignement vertical centré
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Pas de majuscules automatiques
          borderRadius: '10px', // Bordure arrondie
          px:3,
        },
        outlined: {
          borderWidth: '2px', // Bordure plus épaisse pour les boutons outline
        }
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les cartes
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Ombre légère
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '10px', // Bordure arrondie pour les dialogues
          padding: '10px', // Espacement interne
          backgroundColor: '#ffffff', // Fond blanc pour les dialogues
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les sélecteurs
          '& .MuiSelect-icon': {
            color: '#1E2A38', // Couleur de l'icône du sélecteur
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les champs de texte
          '& .MuiInputBase-root': {
            borderRadius: '10px', // Bordure arrondie pour la racine du champ de texte
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1E2A38', // Couleur de la bordure au focus
          },
          '& .MuiInputLabel-root': {
            color: '#1E2A38', // Couleur de l'étiquette du champ de texte
          }
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#d1eaeeff', // Couleur de fond pour l'élément sélectionné
          },
          '&.Mui-selected .MuiListItemText-primary': {
            fontWeight: 600,
          },
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: 'grey', // Couleur du texte principal
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid #d1eaeeff', // Bordure droite
        },
      },
    },
  },
});

export default theme;